// src/features/products/orderProductApi.js
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import Urls from "../../components/Url/Urls";


export const orderProductApi = createApi({
  reducerPath: 'orderProductApi',
  baseQuery: fetchBaseQuery({ baseUrl: Urls.request.get }),
  tagTypes: ['orderProductApi'],
  endpoints: (builder) => ({
    getOrderProducts: builder.query({
      query: () => "getRequestOrderDetails",
      keepUnusedDataFor: 35,
      providesTags: ['orderProductApi'], 
      invalidatesTags: ['orderProductApi'], 
    }),
    createRequestProduct: builder.mutation({
      query: (newOrderProduct) => {
        delete newOrderProduct.supplierName;
        delete newOrderProduct.productName;
        delete newOrderProduct.amount;

        return {
          url: Urls.request.post,
          method: 'POST',
          body: newOrderProduct,
         
        };
      },
      transformResponse: (response, meta, arg) => {
        return response
      },
      invalidatesTags: ['orderProductApi'], 
    }),
    updateOrderProduct: builder.mutation({
      query: (requestData) => {
        return {
          url: Urls.request.update + requestData.Id,
          method: 'PUT',
          body: requestData,
        };
      },
      transformResponse: (response, meta, arg) => {
        return response
      },
      invalidatesTags: ['orderProductApi'],
    }),
  
    deleteOrderProduct: builder.mutation({
      query: (Id) => ({
        url: Urls.request.delete + Id,
        method: 'DELETE',
      }),
      invalidatesTags: ['orderProductApi'], 
    }),

  }),
  keepUnusedDataFor: 1,
});


// ---
export const ModifyRequestOrderApi = createApi({
  reducerPath: 'ModifyRequestOrderApi',
  baseQuery: fetchBaseQuery({ baseUrl: Urls.request.get }),
  tagTypes: ['ModifyRequestOrderApi'],
  endpoints: (builder) => ({
   
    ModifyRequestOrder: builder.mutation({
      query: (requestData) => {
        return {
          url: Urls.request.update_request + requestData.genId,
          method: 'PUT',
          body: requestData,
        };
      },
      transformResponse: (response, meta, arg) => {
        return response
      },
      invalidatesTags: ['ModifyRequestOrderApi'],
    }),
  
  }),
  keepUnusedDataFor: 1,
});

export const ModifyRequestOrderDetailsApi = createApi({
  reducerPath: 'ModifyRequestOrderDetails',
  baseQuery: fetchBaseQuery({ baseUrl: Urls.request.get }),
  tagTypes: ['ModifyRequestOrderDetails'],
  endpoints: (builder) => ({
   
    ModifyRequestOrderDetails: builder.mutation({
      query: (requestData) => {
        return {
          url: Urls.request.update_details + requestData.Id,
          method: 'PUT',
          body: requestData,
        };
      },
      transformResponse: (response, meta, arg) => {
        return response
      },
      invalidatesTags: ['ModifyRequestOrderDetails'],
    }),
  
  }),
  keepUnusedDataFor: 1,
});

// ---


export const requestOrderApi = createApi({
  reducerPath: 'requestOrderApi',
  baseQuery: fetchBaseQuery({ baseUrl: Urls.request.get }),
  tagTypes: ['requestOrderApi'],
  endpoints: (builder) => ({

    createRequestOrder: builder.mutation({
      query: (newMovement) => {
        delete newMovement.productName;
        delete newMovement.supplierName;
        return {
          url: Urls.request.create,
          method: 'POST',
          body: newMovement,
        };
      },
      transformResponse: (response, meta, arg) => {
        return response
      },
      invalidatesTags: ['requestOrderApi'], 
    }),


  }),
  keepUnusedDataFor: 1,
});


export const getRequestedProductByCurrentMonthApi = createApi({
  reducerPath: 'getRequestedProductByCurrentMonthApi',
  baseQuery: fetchBaseQuery({ baseUrl: Urls.request.monthlyRequests }),
  tagTypes: ['getRequestedProductByCurrentMonthApi'],
  endpoints: (builder) => ({
    getRequestedProductByCurrentMonth: builder.query({
      query: () => 'getRequestedProductByCurrentMonth',
      keepUnusedDataFor: 35,
      providesTags: ['getRequestedProductByCurrentMonthApi'],
      invalidatesTags: ['getRequestedProductByCurrentMonthApi'],
    })
  }),
  keepUnusedDataFor: 1,
});


export const getLastGenIdApi = createApi({
  reducerPath: 'getLastGenIdApi',
  baseQuery: fetchBaseQuery({ baseUrl: Urls.request.getLastGenId }),
  endpoints: (builder) => ({
    getLastGenId: builder.query({
      query: () => 'getLastGenId',
    })
  })
});



export const getAllRequestedApi = createApi({
  reducerPath: 'getAllRequestedApi',
  baseQuery: fetchBaseQuery({ baseUrl: Urls.request.getAllRequested }),
  endpoints: (builder) => ({
    getAllRequested: builder.query({
      query: () => 'getAllRequestedProducts',
    })
  })
});


export const getRequestedProductsReportApi = createApi({
  reducerPath: 'getRequestedProductsReportApi',
  baseQuery: fetchBaseQuery({ baseUrl: Urls.request.getRequestedReport }),
  endpoints: (builder) => ({
    getRequestedReport: builder.query({
      query: () => 'getRequestedProductsReport',
    })
  })
});















export const {
  useModifyRequestOrderMutation
} = ModifyRequestOrderApi


export const {
  useModifyRequestOrderDetailsMutation
} = ModifyRequestOrderDetailsApi









export const {
  useGetOrderProductsQuery,
  useCreateRequestProductMutation,
  useUpdateOrderProductMutation,
  useDeleteOrderProductMutation,
} = orderProductApi;

export const {
  useCreateRequestOrderMutation
} = requestOrderApi;

export const {
  useGetRequestedProductByCurrentMonthQuery
} = getRequestedProductByCurrentMonthApi;



export const {
  useGetLastGenIdQuery
} = getLastGenIdApi

export const {
  useGetAllRequestedQuery
} = getAllRequestedApi


export const {
  useGetRequestedReportQuery
} = getRequestedProductsReportApi




